import { Home, Calendar, Compass, User, type LucideIcon } from 'lucide-react';
import type { FeatureFlags } from '../hooks/useFeatureFlags';

export interface NavItem {
  /** Display label — kept identical across mobile and desktop surfaces. */
  name: string;
  path: string;
  exact: boolean;
  Icon: LucideIcon;
  /** Optional feature-flag gate — item is hidden when the flag is off. */
  requiresFlag?: keyof FeatureFlags;
}

/**
 * Single source of truth for primary navigation, shared by `BottomNav` (mobile)
 * and `DesktopSidebar` so labels and icons can never drift between surfaces.
 * Visible order is the same on both; `Discover` is gated behind `discoveryEnabled`.
 */
export const NAV_ITEMS: NavItem[] = [
  { name: 'Home', path: '/', exact: true, Icon: Home },
  { name: 'Events', path: '/events', exact: false, Icon: Calendar },
  {
    name: 'Discover',
    path: '/discovery',
    exact: false,
    Icon: Compass,
    requiresFlag: 'discoveryEnabled',
  },
  { name: 'Profile', path: '/profile', exact: false, Icon: User },
];

export const HIDDEN_NAVBAR_PATHS = [
  '/signup',
  '/login',
  '/forgot-password',
  '/join',
  '/terms',
  '/privacy',
];

export const HIDDEN_BOTTOM_NAV_PATHS = [
  '/signup',
  '/login',
  '/forgot-password',
  '/join',
  '/create',
  '/terms',
  '/privacy',
];

export const shouldHideNavbar = (pathname: string): boolean => {
  if (HIDDEN_NAVBAR_PATHS.includes(pathname)) return true;
  if (pathname.startsWith('/join')) return true;
  if (pathname.startsWith('/onboarding')) return true;
  if (pathname.startsWith('/room/')) return true;
  if (pathname.startsWith('/availability')) return true;
  if (pathname.startsWith('/interests')) return true;
  return false;
};

export const shouldHideBottomNav = (pathname: string): boolean => {
  if (HIDDEN_BOTTOM_NAV_PATHS.includes(pathname)) return true;
  if (pathname.startsWith('/join')) return true;
  if (pathname.startsWith('/onboarding')) return true;
  if (pathname.startsWith('/room/')) return true;
  if (pathname.startsWith('/availability')) return true;
  if (pathname.startsWith('/interests')) return true;
  return false;
};
